/* eslint-disable */
import moment from 'moment';
import cogsAnalyticsServices from '@/Services/Analytics Services/cogsAnalytics.services';
import invAnalyticsServices from '@/Services/Analytics Services/invAnalytics.services';

export const fetchInitialData = async (state) => {
	console.log(state, 'state');

	const reqData = {
		dateFilter: state?.dateFilter,
		grouping: {
			active: true,
			type: state?.selectedTab,
			currentSelection: state?.grouping?.currentSelection ?? 'brand',
			selection: {
				category: state?.grouping?.selection?.category ?? null,
				subCategory: state?.grouping?.selection?.subCategory ?? null,
				region: null,
				city: null,
				brand: null,
			},
		},
		dateRangeFilter: {},
		...(state?.selectedTab !== 'periodWise' && {
			dateRangeFilter: {
				from: moment(state?.dateRangeObj?.from).format('YYYY-MM-DD'),
				to: moment(state?.dateRangeObj?.to).format('YYYY-MM-DD'),
			},
		}),
		analysisType: 'INVENTORY',
		analysisSubType: state?.analysisSubType,
		analysisPhase: state?.analysisPhase,
		showInternalData: false,
		yAxis: state?.selectedChartTab,
		perUnit: state?.perUnitToggle,
		productIdsList: state?.filters?.product?.id
			? [state?.filters?.product?.id]
			: [],
		processIds: state?.filters?.processIds ?? [],
		shiftId: state?.filters?.type ? state?.filters?.type : null,
		storeFilter:
			state?.filters?.multiStore?.id?.length > 0
				? state?.filters?.multiStore?.id
				: state?.filters?.store?.id
				? [state?.filters?.store?.id]
				: [],
		hourWisePlot:
			state?.filters?.timeTypeFilter === 'PerHour' ||
			state?.filters?.timeTypeFilter === 'Cummulative'
				? true
				: false,
		...(state?.isCache ? { NO_CACHE: true } : {}),
	};
	const req = {
		data: {
			...reqData,
		},
	};
	const response = await invAnalyticsServices.fetchInvAnalysisGraph({
		req,
	});
	if (
		state?.selectedTab === 'periodWise' &&
		state?.dateFilter?.currentSelection?.toLowerCase() === 'day' &&
		state?.filters?.timeTypeFilter?.toLowerCase() === 'cummulative' &&
		Array.isArray(response?.data?.chartData?.dataset)
	) {
		const cummlativeChartData = response?.data?.chartData?.dataset?.map(
			(ele) => {
				let cummlativeDataValue = 0;
				return {
					...ele,
					data: ele?.data?.map((item) => {
						cummlativeDataValue += item;
						return cummlativeDataValue;
					}),
				};
			}
		);

		const data = {
			chartData: {
				...response?.data?.chartData,
				dataset: cummlativeChartData,
			},
			statsData: response?.data?.statsData,
			cacheTime: response?.cacheTime,
		};
		return data;
	}
	return { ...response?.data, cacheTime: response?.cacheTime };
};
